import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import CompanySettingsTabs from './CompanySettingsTabs';
import Button from '../../../components/Button';
import axios from 'axios';
import produce from 'immer';
import Setting from './Components/Setting';
import FtpForm from './Components/FtpForm';
import { useUserContext } from '../../../context/UserContext';

const OuterWrapper = styled.div`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  margin: 40px auto 70px;
  max-width: 1305px;
`;
const ButtonWrap = styled.div`
  border-bottom: 1px solid #e5e5ea;
  display: flex;
  justify-content: flex-end;
`;

const defaultFtpValues: FtpSetting = {
  password: '',
  host: '',
  username: '',
};
interface Props {
  clientId: number;
}
const CompanySettingsPage = (props: Props) => {
  const [indexSelected, setIndexSelected] = useState(0);
  const [saved, setIsSaved] = useState(false);
  const [companySettings, setCompanySettings] = useState<ClientSetting>({
    clientId: null,
    ftpSetting: defaultFtpValues,
    newClientSettings: [],
  });
  const [allowFtpChange, setAllowFtpChange] = useState(false);
  const [saving, setSaving] = useState(false);
  const { user } = useUserContext();

  const changeFtpValue = (label: keyof FtpSetting, value: any) => {
    const newCompanySettings = produce(companySettings, draft => {
      (draft.ftpSetting[label] as any) = value;
    });
    setCompanySettings(newCompanySettings);
  };

  const getAdditionalContent = (
    settingName: string,
    ftpSetting: FtpSetting = defaultFtpValues,
    func: any,
    handleAfterChange: () => void
  ) => {
    const mapped = {
      ftp: (
        <FtpForm
          companyFTPSetting={{
            clientId: ftpSetting.clientId,
            host: ftpSetting.host,
            id: ftpSetting.id,
            password: ftpSetting.password,
            username: ftpSetting.username,
          }}
          changeFtpValue={func}
          handleAfterChange={handleAfterChange}
          allowFtpChange={allowFtpChange}
        />
      ),
    };

    return mapped[settingName];
  };

  const getClientSettings = async () => {
    const { data } = await axios.get<ClientSetting>(`/api/ClientProfile/GetClientSettings/${props.clientId}`);
    setAllowFtpChange(!data.ftpSetting?.password);
    setCompanySettings({
      ...data,
      ftpSetting: data.ftpSetting || { ...defaultFtpValues, clientId: data.clientId },
    });
  };

  const changeCompanySettings = (settingName: string, value: any) => {
    const settingIndex = companySettings.newClientSettings.findIndex(
      c => c.setting.settingName === settingName
    );
    const newCompanySettings = produce(companySettings, draft => {
      (draft.newClientSettings[settingIndex].selectedOptionId as any) = value;
    });
    setCompanySettings(newCompanySettings);
  };

  const saveChanges = async () => {
    setSaving(true);
    await axios.post(`/api/clientProfile/UpdateClientSettings/${props.clientId}`, companySettings);
    setSaving(false);
    setIsSaved(true);
    setTimeout(() => {
      setIsSaved(false);
    }, 2000);
    getClientSettings();
  };

  useEffect(() => {
    if (props.clientId) {
      getClientSettings();
    }
  }, [props.clientId]);

  return (
    <OuterWrapper>
      <CompanySettingsTabs indexSelected={indexSelected} setIndexSelected={setIndexSelected} />
      {indexSelected === 0 && (
        <div>
          {companySettings.newClientSettings
            .filter(cs => cs.setting.searchTypeId === null)
            .map((k, index) => (
              <Setting index={index} clientSetting={k} setCompanySettings={changeCompanySettings}>
                {getAdditionalContent(
                  k.setting.settingName,
                  companySettings.ftpSetting,
                  changeFtpValue,
                  getClientSettings
                )}
              </Setting>
            ))}
        </div>
      )}
      {indexSelected === 1 && (
        <div>
          {companySettings.newClientSettings
            .filter(cs => cs.setting.searchTypeId === 20)
            .map((k, index) => (
              <Setting index={index} clientSetting={k} setCompanySettings={changeCompanySettings}>
                {k.additionalContent}
              </Setting>
            ))}
        </div>
      )}
      <ButtonWrap>
        <div style={{ padding: 40, display: 'flex' }}>
          <Button buttonType="ButtonSecondarySmall" buttonText="Cancel" onClick={getClientSettings} />
          <Button
            buttonText={saved ? 'Saved!' : 'Save Changes'}
            onClick={saveChanges}
            style={{ marginLeft: 8 }}
            disabled={saving}
            loadingStatus={saving}
          />
        </div>
      </ButtonWrap>
    </OuterWrapper>
  );
};

export default CompanySettingsPage;
